/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crosspostingfbstory2Inputs */

const en_crosspostingfbstory2 = /** @type {(inputs: Crosspostingfbstory2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Story`)
};

const de_crosspostingfbstory2 = /** @type {(inputs: Crosspostingfbstory2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Story`)
};

/**
* | output |
* | --- |
* | "Story" |
*
* @param {Crosspostingfbstory2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const crosspostingfbstory2 = /** @type {((inputs?: Crosspostingfbstory2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crosspostingfbstory2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crosspostingfbstory2(inputs)
	return de_crosspostingfbstory2(inputs)
});
export { crosspostingfbstory2 as "crosspostingFbStory" }